module.exports = __webpack_public_path__ + "src/assets/img/door_left.ba1e3a67.svg";